import { useStaticQuery, graphql } from 'gatsby'
import { ResourceCoreData } from './types'

const useCarouselData = () => {
  const {
    carouselResources,
  }: { carouselResources: { nodes: ResourceCoreData[] } } =
    useStaticQuery(graphql`
      query carouselResourcesQuery {
        carouselResources: allAirtable(
          filter: {
            table: { eq: "Publishable explore page" }
            data: { Featured: { eq: true } }
          }
        ) {
          nodes {
            data {
              Title
              Owner
              Description
              Topic
              Data_access
              Tags
              Image {
                localFiles {
                  childImageSharp {
                    gatsbyImageData(height: 200, placeholder: BLURRED)
                  }
                }
              }
              Filter_1
              Filter_2
              Filter_3
              Filter_4
              Filter_5
              Filter_6
              Filter_7
              Filter_8
            }
          }
        }
      }
    `)
  return carouselResources
}

export default useCarouselData
